import(/* webpackMode: "eager", webpackExports: ["GroupDirectory"] */ "/workspace/web/platform/groups/GroupDirectory.tsx");
